import { ForgottenCheckinDto, ForgottenCheckoutDto, User, UserCreateDTO, UserStatus, UserUpdateDTO, WorkScheduleResponseDto, YearlyDetailsForEmployeeResponseDto, YearlyWorkStatsResponseDto } from "../../types/user.types";
import { Salary, SalaryUpdateDTO } from "../../types/salary.types";
import apiService from "../api/api.service";
import { UserBirthdaysResponseDto } from "../../types/user.types";
import assetService from "../asset/asset.service";

class UserService {
  private static instance: UserService;

  private constructor() { }

  public static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  /**
   * Get all users
   */
  public async getUsers(): Promise<User[]> {
    const response = await apiService.get<User[]>(`/users`);
    return response;
  }

  public async getUsersByBranchId(companyId: number, branchId: number): Promise<User[]> {
    const response = await apiService.get<User[]>(`/users/branchId=${branchId}`);
    return response;
  }

  /**
   * Get a user by ID
   * @param id User ID
   */
  public async getUserById(id: number): Promise<User> {
    const response = await apiService.get<User>(`/users/${id}`);
    return response;
  }

  /**
   * Create a new user
   * @param data User data
   */
  public async createUser(data: UserCreateDTO): Promise<User> {
    const response = await apiService.post<User>("/users", data);
    //console.log(response);

    return response;
  }



  /**
   * Update an existing user
   * @param id User ID
   * @param data Updated user data
   */
  public async updateUser(id: number, data: UserUpdateDTO): Promise<User> {
    const response = await apiService.put<User>(`/users/${id}`, data);
    return response;
  }
  public async updateUserAdmin(id: number, data: UserUpdateDTO): Promise<User> {
    const response = await apiService.patch<User>(`/users/${id}`, data);
    return response;
  }
  public async updateUserStatus(id: number, status: UserStatus): Promise<User> {
    // Eğer kullanıcı işten çıkarılıyorsa zimmet kontrolü yap
    if (status === UserStatus.RESIGNED || status === UserStatus.DELETED) {
      const assetCheck = await assetService.checkUserUnreturnedAssets(id);
      if (assetCheck.hasUnreturnedAssets) {
        const assetList = assetCheck.assets.map(asset => `• ${asset.name} (${asset.serialNumber})`).join('\n');
        throw new Error(
          `Bu kullanıcının ${assetCheck.assets.length} adet iade edilmemiş zimmeti bulunmaktadır:\n\n${assetList}\n\nİşten çıkarma işlemini gerçekleştirmek için önce tüm zimmetlerin iade edilmesi gerekmektedir.`
        );
      }
    }

    const response = await apiService.patch<User>(`/users/status/${id}`, { status });
    return response;
  }
  /**
   * Delete a user
   * @param id User ID
   */
  public async deleteUser(id: number): Promise<void> {
    await apiService.delete(`/users/${id}`);
  }
  public async hardDeleteUser(id: number): Promise<void> {
    await apiService.delete(`/users/hard/${id}`);
  }

  public async getSalaryByUserId(userId: number): Promise<Salary[]> {
    const response = await apiService.get<Salary[]>(`/salary/${userId}`);
    return response;
  }

  public async getUsersBirthdays(companyId: number): Promise<UserBirthdaysResponseDto> {
    const response = await apiService.get<UserBirthdaysResponseDto>(`/users/birthdays/${companyId}`);
    return response;
  }

  public async getYearlyDetails(userId: number): Promise<YearlyDetailsForEmployeeResponseDto> {
    const response = await apiService.get<YearlyDetailsForEmployeeResponseDto>(`/users/annual-report/${userId}`);
    return response;
  }

  public async getYearlyWorkStats(userId: number): Promise<YearlyWorkStatsResponseDto> {
    const response = await apiService.get<YearlyWorkStatsResponseDto>(`/users/work-stats/${userId}`);
    return response;
  }

  public async getWorkSchedule(userId: number): Promise<WorkScheduleResponseDto> {
    const response = await apiService.get<WorkScheduleResponseDto>(`/users/work-schedule/${userId}`);
    return response;
  }

  public async getUserByEmail(email: string): Promise<User> {
    const response = await apiService.get<User>(`/users/email/${email}`);
    return response;
  }

  public async updateSalary(userId: number, newAmount: number): Promise<SalaryUpdateDTO> {
    const response = await apiService.post<SalaryUpdateDTO>(`/salary/update-salary`, { amount: newAmount, userId });
    return response;
  }

  public async resetDevice(targetUserId: number): Promise<void> {
    await apiService.post(`/auth/reset-device`, { targetUserId });
  }

  public async getForgottenCheckouts(): Promise<ForgottenCheckoutDto[]> {
    const response = await apiService.get<ForgottenCheckoutDto[]>(`/daily-records/forgotten-checkouts`);
    return response;
  }
  public async getForgottenCheckins(checkTime?: string): Promise<ForgottenCheckinDto[]> {
    const queryParams = checkTime ? `?checkTime=${checkTime}` : '';
    const response = await apiService.get<ForgottenCheckinDto[]>(`/daily-records/forgotten-checkins${queryParams}`);
    return response;
  }
}

export default UserService.getInstance();